export const Helpers = {
    swapDateMonth: function (dateString) {
        if (!dateString) {
            return;
        }
        dateString = dateString.trim();
        let getCountryCode = window.navigator.language;
        let [_, countryCode] = getCountryCode.split("-");
        if (!countryCode) {
            countryCode = "US";
        }
        switch (countryCode.toUpperCase()) {
            case "US":
            case "CA":
                return dateString;
            default: {
                const pattern = /(\w+)\s+?(\d+)[, ]+?(\d+)/;
                const mat = dateString.match(pattern);
                let dateStr = dateString;
                if (mat && mat.length === 4) {
                    let [month, date, year] = mat.slice(1);
                    dateStr = `${date} ${month}, ${year}`;
                }
                return dateStr;
            }
        }
    },
};
